// extracted by css-extract-rspack-plugin
export default {"page":"gxWLK","intro":"SJJgK","subtitle":"y7Qqh","games":"o4Uki","seo_override":"Njvvj","seoOverride":"Njvvj","#":"ozSgU","trending":"YdcPT"};